import { useEffect, useState } from 'react';

export const useRerenderValue = ({ state, resetState, time = 0 }) => {
  const [mutationState, setMutationState] = useState(state);

  useEffect(() => {
    setMutationState(state);
  }, [state]);

  const rerender = () => {
    setMutationState(resetState);
    setTimeout(() => {
      setMutationState(state);
    }, time);
  };

  return [mutationState, rerender];
};
